// extracted by mini-css-extract-plugin
module.exports = {"content":"i_MH","left":"i_MI","right":"i_MJ","body":"i_MK","column":"i_ML","wrapper":"i_MM"};